import { DEFAULT_ARTICLE_DATA } from "../utils/constants/common/defaultArticleData";
import { IArticleData } from "../utils/interfaces/common/XArticle.interfaces";

type TGenerateArticleData = (pageLimit?: number) => IArticleData[];

export const generateArticleData: TGenerateArticleData = (pageLimit) => {
  return Array(pageLimit || 8)
    .fill(DEFAULT_ARTICLE_DATA)
    .map((a, i) => {
      const random = Math.round(Math.random() * 10);

      return {
        ...a,
        name: "Fashionable Hooded Shoes " + i,
        categories: "BAGS & BACKPACKS, WOMEN",
        id: (i + 1).toString(),
        price: random * a.price,
        discount: random * a.discount,
        reviewCount: random * a.reviewCount,
      };
    });
};
